/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as MarketingIndexRouteImport } from './routes/_marketing/index'
import { Route as KbCRouteImport } from './routes/kb/c'
import { Route as KbARouteImport } from './routes/kb/a'
import { Route as MarketingWebCrawlingForResearchRouteImport } from './routes/_marketing/web-crawling-for-research'
import { Route as MarketingTermsRouteImport } from './routes/_marketing/terms'
import { Route as MarketingSubprocessorsRouteImport } from './routes/_marketing/subprocessors'
import { Route as MarketingShareWithEmployeesRouteImport } from './routes/_marketing/share-with-employees'
import { Route as MarketingRateLimitingRouteImport } from './routes/_marketing/rate-limiting'
import { Route as MarketingPrivacyRouteImport } from './routes/_marketing/privacy'
import { Route as MarketingPricingRouteImport } from './routes/_marketing/pricing'
import { Route as MarketingOnTopicResponsesRouteImport } from './routes/_marketing/on-topic-responses'
import { Route as MarketingNoTechnicalKnowledgeRequiredRouteImport } from './routes/_marketing/no-technical-knowledge-required'
import { Route as MarketingExportIntegrationsRouteImport } from './routes/_marketing/export-integrations'
import { Route as MarketingDataProcessingAgreementRouteImport } from './routes/_marketing/data-processing-agreement'
import { Route as MarketingContactRouteImport } from './routes/_marketing/contact'
import { Route as MarketingConnectMultipleSourcesRouteImport } from './routes/_marketing/connect-multiple-sources'
import { Route as MarketingUseCasesIndexRouteImport } from './routes/_marketing/use-cases/index'
import { Route as MarketingBlogIndexRouteImport } from './routes/_marketing/blog/index'
import { Route as MarketingUseCasesSlugRouteImport } from './routes/_marketing/use-cases/$slug'
import { Route as MarketingBlogSlugRouteImport } from './routes/_marketing/blog/$slug'

const MarketingRoute = MarketingRouteImport.update({
  id: '/_marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketingRoute,
} as any)
const KbCRoute = KbCRouteImport.update({
  id: '/kb/c',
  path: '/kb/c',
  getParentRoute: () => rootRouteImport,
} as any)
const KbARoute = KbARouteImport.update({
  id: '/kb/a',
  path: '/kb/a',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingWebCrawlingForResearchRoute =
  MarketingWebCrawlingForResearchRouteImport.update({
    id: '/web-crawling-for-research',
    path: '/web-crawling-for-research',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingTermsRoute = MarketingTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingSubprocessorsRoute = MarketingSubprocessorsRouteImport.update({
  id: '/subprocessors',
  path: '/subprocessors',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingShareWithEmployeesRoute =
  MarketingShareWithEmployeesRouteImport.update({
    id: '/share-with-employees',
    path: '/share-with-employees',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingRateLimitingRoute = MarketingRateLimitingRouteImport.update({
  id: '/rate-limiting',
  path: '/rate-limiting',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingPrivacyRoute = MarketingPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingPricingRoute = MarketingPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingOnTopicResponsesRoute =
  MarketingOnTopicResponsesRouteImport.update({
    id: '/on-topic-responses',
    path: '/on-topic-responses',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingNoTechnicalKnowledgeRequiredRoute =
  MarketingNoTechnicalKnowledgeRequiredRouteImport.update({
    id: '/no-technical-knowledge-required',
    path: '/no-technical-knowledge-required',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingExportIntegrationsRoute =
  MarketingExportIntegrationsRouteImport.update({
    id: '/export-integrations',
    path: '/export-integrations',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingDataProcessingAgreementRoute =
  MarketingDataProcessingAgreementRouteImport.update({
    id: '/data-processing-agreement',
    path: '/data-processing-agreement',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingContactRoute = MarketingContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingConnectMultipleSourcesRoute =
  MarketingConnectMultipleSourcesRouteImport.update({
    id: '/connect-multiple-sources',
    path: '/connect-multiple-sources',
    getParentRoute: () => MarketingRoute,
  } as any)
const MarketingUseCasesIndexRoute = MarketingUseCasesIndexRouteImport.update({
  id: '/use-cases/',
  path: '/use-cases/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingBlogIndexRoute = MarketingBlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingUseCasesSlugRoute = MarketingUseCasesSlugRouteImport.update({
  id: '/use-cases/$slug',
  path: '/use-cases/$slug',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingBlogSlugRoute = MarketingBlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => MarketingRoute,
} as any)

export interface FileRoutesByFullPath {
  '/connect-multiple-sources': typeof MarketingConnectMultipleSourcesRoute
  '/contact': typeof MarketingContactRoute
  '/data-processing-agreement': typeof MarketingDataProcessingAgreementRoute
  '/export-integrations': typeof MarketingExportIntegrationsRoute
  '/no-technical-knowledge-required': typeof MarketingNoTechnicalKnowledgeRequiredRoute
  '/on-topic-responses': typeof MarketingOnTopicResponsesRoute
  '/pricing': typeof MarketingPricingRoute
  '/privacy': typeof MarketingPrivacyRoute
  '/rate-limiting': typeof MarketingRateLimitingRoute
  '/share-with-employees': typeof MarketingShareWithEmployeesRoute
  '/subprocessors': typeof MarketingSubprocessorsRoute
  '/terms': typeof MarketingTermsRoute
  '/web-crawling-for-research': typeof MarketingWebCrawlingForResearchRoute
  '/kb/a': typeof KbARoute
  '/kb/c': typeof KbCRoute
  '/': typeof MarketingIndexRoute
  '/blog/$slug': typeof MarketingBlogSlugRoute
  '/use-cases/$slug': typeof MarketingUseCasesSlugRoute
  '/blog': typeof MarketingBlogIndexRoute
  '/use-cases': typeof MarketingUseCasesIndexRoute
}
export interface FileRoutesByTo {
  '/connect-multiple-sources': typeof MarketingConnectMultipleSourcesRoute
  '/contact': typeof MarketingContactRoute
  '/data-processing-agreement': typeof MarketingDataProcessingAgreementRoute
  '/export-integrations': typeof MarketingExportIntegrationsRoute
  '/no-technical-knowledge-required': typeof MarketingNoTechnicalKnowledgeRequiredRoute
  '/on-topic-responses': typeof MarketingOnTopicResponsesRoute
  '/pricing': typeof MarketingPricingRoute
  '/privacy': typeof MarketingPrivacyRoute
  '/rate-limiting': typeof MarketingRateLimitingRoute
  '/share-with-employees': typeof MarketingShareWithEmployeesRoute
  '/subprocessors': typeof MarketingSubprocessorsRoute
  '/terms': typeof MarketingTermsRoute
  '/web-crawling-for-research': typeof MarketingWebCrawlingForResearchRoute
  '/kb/a': typeof KbARoute
  '/kb/c': typeof KbCRoute
  '/': typeof MarketingIndexRoute
  '/blog/$slug': typeof MarketingBlogSlugRoute
  '/use-cases/$slug': typeof MarketingUseCasesSlugRoute
  '/blog': typeof MarketingBlogIndexRoute
  '/use-cases': typeof MarketingUseCasesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_marketing': typeof MarketingRouteWithChildren
  '/_marketing/connect-multiple-sources': typeof MarketingConnectMultipleSourcesRoute
  '/_marketing/contact': typeof MarketingContactRoute
  '/_marketing/data-processing-agreement': typeof MarketingDataProcessingAgreementRoute
  '/_marketing/export-integrations': typeof MarketingExportIntegrationsRoute
  '/_marketing/no-technical-knowledge-required': typeof MarketingNoTechnicalKnowledgeRequiredRoute
  '/_marketing/on-topic-responses': typeof MarketingOnTopicResponsesRoute
  '/_marketing/pricing': typeof MarketingPricingRoute
  '/_marketing/privacy': typeof MarketingPrivacyRoute
  '/_marketing/rate-limiting': typeof MarketingRateLimitingRoute
  '/_marketing/share-with-employees': typeof MarketingShareWithEmployeesRoute
  '/_marketing/subprocessors': typeof MarketingSubprocessorsRoute
  '/_marketing/terms': typeof MarketingTermsRoute
  '/_marketing/web-crawling-for-research': typeof MarketingWebCrawlingForResearchRoute
  '/kb/a': typeof KbARoute
  '/kb/c': typeof KbCRoute
  '/_marketing/': typeof MarketingIndexRoute
  '/_marketing/blog/$slug': typeof MarketingBlogSlugRoute
  '/_marketing/use-cases/$slug': typeof MarketingUseCasesSlugRoute
  '/_marketing/blog/': typeof MarketingBlogIndexRoute
  '/_marketing/use-cases/': typeof MarketingUseCasesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/connect-multiple-sources'
    | '/contact'
    | '/data-processing-agreement'
    | '/export-integrations'
    | '/no-technical-knowledge-required'
    | '/on-topic-responses'
    | '/pricing'
    | '/privacy'
    | '/rate-limiting'
    | '/share-with-employees'
    | '/subprocessors'
    | '/terms'
    | '/web-crawling-for-research'
    | '/kb/a'
    | '/kb/c'
    | '/'
    | '/blog/$slug'
    | '/use-cases/$slug'
    | '/blog'
    | '/use-cases'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/connect-multiple-sources'
    | '/contact'
    | '/data-processing-agreement'
    | '/export-integrations'
    | '/no-technical-knowledge-required'
    | '/on-topic-responses'
    | '/pricing'
    | '/privacy'
    | '/rate-limiting'
    | '/share-with-employees'
    | '/subprocessors'
    | '/terms'
    | '/web-crawling-for-research'
    | '/kb/a'
    | '/kb/c'
    | '/'
    | '/blog/$slug'
    | '/use-cases/$slug'
    | '/blog'
    | '/use-cases'
  id:
    | '__root__'
    | '/_marketing'
    | '/_marketing/connect-multiple-sources'
    | '/_marketing/contact'
    | '/_marketing/data-processing-agreement'
    | '/_marketing/export-integrations'
    | '/_marketing/no-technical-knowledge-required'
    | '/_marketing/on-topic-responses'
    | '/_marketing/pricing'
    | '/_marketing/privacy'
    | '/_marketing/rate-limiting'
    | '/_marketing/share-with-employees'
    | '/_marketing/subprocessors'
    | '/_marketing/terms'
    | '/_marketing/web-crawling-for-research'
    | '/kb/a'
    | '/kb/c'
    | '/_marketing/'
    | '/_marketing/blog/$slug'
    | '/_marketing/use-cases/$slug'
    | '/_marketing/blog/'
    | '/_marketing/use-cases/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  MarketingRoute: typeof MarketingRouteWithChildren
  KbARoute: typeof KbARoute
  KbCRoute: typeof KbCRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_marketing': {
      id: '/_marketing'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing/': {
      id: '/_marketing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/kb/c': {
      id: '/kb/c'
      path: '/kb/c'
      fullPath: '/kb/c'
      preLoaderRoute: typeof KbCRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kb/a': {
      id: '/kb/a'
      path: '/kb/a'
      fullPath: '/kb/a'
      preLoaderRoute: typeof KbARouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing/web-crawling-for-research': {
      id: '/_marketing/web-crawling-for-research'
      path: '/web-crawling-for-research'
      fullPath: '/web-crawling-for-research'
      preLoaderRoute: typeof MarketingWebCrawlingForResearchRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/terms': {
      id: '/_marketing/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof MarketingTermsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/subprocessors': {
      id: '/_marketing/subprocessors'
      path: '/subprocessors'
      fullPath: '/subprocessors'
      preLoaderRoute: typeof MarketingSubprocessorsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/share-with-employees': {
      id: '/_marketing/share-with-employees'
      path: '/share-with-employees'
      fullPath: '/share-with-employees'
      preLoaderRoute: typeof MarketingShareWithEmployeesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/rate-limiting': {
      id: '/_marketing/rate-limiting'
      path: '/rate-limiting'
      fullPath: '/rate-limiting'
      preLoaderRoute: typeof MarketingRateLimitingRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/privacy': {
      id: '/_marketing/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof MarketingPrivacyRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/pricing': {
      id: '/_marketing/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof MarketingPricingRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/on-topic-responses': {
      id: '/_marketing/on-topic-responses'
      path: '/on-topic-responses'
      fullPath: '/on-topic-responses'
      preLoaderRoute: typeof MarketingOnTopicResponsesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/no-technical-knowledge-required': {
      id: '/_marketing/no-technical-knowledge-required'
      path: '/no-technical-knowledge-required'
      fullPath: '/no-technical-knowledge-required'
      preLoaderRoute: typeof MarketingNoTechnicalKnowledgeRequiredRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/export-integrations': {
      id: '/_marketing/export-integrations'
      path: '/export-integrations'
      fullPath: '/export-integrations'
      preLoaderRoute: typeof MarketingExportIntegrationsRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/data-processing-agreement': {
      id: '/_marketing/data-processing-agreement'
      path: '/data-processing-agreement'
      fullPath: '/data-processing-agreement'
      preLoaderRoute: typeof MarketingDataProcessingAgreementRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/contact': {
      id: '/_marketing/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof MarketingContactRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/connect-multiple-sources': {
      id: '/_marketing/connect-multiple-sources'
      path: '/connect-multiple-sources'
      fullPath: '/connect-multiple-sources'
      preLoaderRoute: typeof MarketingConnectMultipleSourcesRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/use-cases/': {
      id: '/_marketing/use-cases/'
      path: '/use-cases'
      fullPath: '/use-cases'
      preLoaderRoute: typeof MarketingUseCasesIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/blog/': {
      id: '/_marketing/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof MarketingBlogIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/use-cases/$slug': {
      id: '/_marketing/use-cases/$slug'
      path: '/use-cases/$slug'
      fullPath: '/use-cases/$slug'
      preLoaderRoute: typeof MarketingUseCasesSlugRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/blog/$slug': {
      id: '/_marketing/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof MarketingBlogSlugRouteImport
      parentRoute: typeof MarketingRoute
    }
  }
}

interface MarketingRouteChildren {
  MarketingConnectMultipleSourcesRoute: typeof MarketingConnectMultipleSourcesRoute
  MarketingContactRoute: typeof MarketingContactRoute
  MarketingDataProcessingAgreementRoute: typeof MarketingDataProcessingAgreementRoute
  MarketingExportIntegrationsRoute: typeof MarketingExportIntegrationsRoute
  MarketingNoTechnicalKnowledgeRequiredRoute: typeof MarketingNoTechnicalKnowledgeRequiredRoute
  MarketingOnTopicResponsesRoute: typeof MarketingOnTopicResponsesRoute
  MarketingPricingRoute: typeof MarketingPricingRoute
  MarketingPrivacyRoute: typeof MarketingPrivacyRoute
  MarketingRateLimitingRoute: typeof MarketingRateLimitingRoute
  MarketingShareWithEmployeesRoute: typeof MarketingShareWithEmployeesRoute
  MarketingSubprocessorsRoute: typeof MarketingSubprocessorsRoute
  MarketingTermsRoute: typeof MarketingTermsRoute
  MarketingWebCrawlingForResearchRoute: typeof MarketingWebCrawlingForResearchRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
  MarketingBlogSlugRoute: typeof MarketingBlogSlugRoute
  MarketingUseCasesSlugRoute: typeof MarketingUseCasesSlugRoute
  MarketingBlogIndexRoute: typeof MarketingBlogIndexRoute
  MarketingUseCasesIndexRoute: typeof MarketingUseCasesIndexRoute
}

const MarketingRouteChildren: MarketingRouteChildren = {
  MarketingConnectMultipleSourcesRoute: MarketingConnectMultipleSourcesRoute,
  MarketingContactRoute: MarketingContactRoute,
  MarketingDataProcessingAgreementRoute: MarketingDataProcessingAgreementRoute,
  MarketingExportIntegrationsRoute: MarketingExportIntegrationsRoute,
  MarketingNoTechnicalKnowledgeRequiredRoute:
    MarketingNoTechnicalKnowledgeRequiredRoute,
  MarketingOnTopicResponsesRoute: MarketingOnTopicResponsesRoute,
  MarketingPricingRoute: MarketingPricingRoute,
  MarketingPrivacyRoute: MarketingPrivacyRoute,
  MarketingRateLimitingRoute: MarketingRateLimitingRoute,
  MarketingShareWithEmployeesRoute: MarketingShareWithEmployeesRoute,
  MarketingSubprocessorsRoute: MarketingSubprocessorsRoute,
  MarketingTermsRoute: MarketingTermsRoute,
  MarketingWebCrawlingForResearchRoute: MarketingWebCrawlingForResearchRoute,
  MarketingIndexRoute: MarketingIndexRoute,
  MarketingBlogSlugRoute: MarketingBlogSlugRoute,
  MarketingUseCasesSlugRoute: MarketingUseCasesSlugRoute,
  MarketingBlogIndexRoute: MarketingBlogIndexRoute,
  MarketingUseCasesIndexRoute: MarketingUseCasesIndexRoute,
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(
  MarketingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  MarketingRoute: MarketingRouteWithChildren,
  KbARoute: KbARoute,
  KbCRoute: KbCRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
